<template>
  <div>
    <v-toolbar dense tabs color="primary darken-2" dark class="page_title">
      <v-toolbar-title class="pa-0 pr-0 mt-1">
        <v-layout row>
          <v-flex xs10 sm11 text-xs-left>
            <a href="javascript: history.go(-1)" class="pa-0">
              <v-btn flat fab small class="pa-0" aria-label="Go back">
                <i class="fas fa-arrow-left headline"></i>
              </v-btn>
            </a>
            Forgotten Password
          </v-flex>
          <v-flex xs2 sm1 text-xs-right>
            <router-link :to="$store.state.close_url" class="pa-0 text-xs-right">
              <v-btn flat fab small class="pa-0" aria-label="Close">
                <i class="fas fa-close headline"></i>
              </v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-toolbar-title>
    </v-toolbar>

    <v-container>
      <v-layout row>
        <v-flex xs12 md8 offset-md2 lg6 offset-lg3>
          <v-slide-y-transition mode="out-in">
            <div>
              <v-card class="blue lighten-4">
                <v-card-text style="font-size: 12px;">
                  <p class="dark--text subheading pa-0 ma-0 text-xs-center">
                    <span>Please enter your registered email address to reset your password</span>
                  </p>
                </v-card-text>
              </v-card>
              <v-card color="white pa-3" class="white-bg">
                <v-layout row>
                  <v-flex xs12 md10 offset-md1>
                    <v-text-field
                      id="email"
                      label="Email"
                      single-line
                      color="teal"
                      v-model="email"
                      required
                      :rules="emailRules"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <div class="text-xs-center">
                  <v-btn
                    class="white--text elevation-6"
                    round
                    color="teal darken-2"
                    @click="requestPasswordReset"
                    :disabled="isLoading || !emailValid"
                  >
                    <v-progress-circular
                      v-if="isLoading"
                      indeterminate
                      color="white"
                      size="20"
                      width="2"
                      class="mr-2"
                    ></v-progress-circular>
                    <span>{{ isLoading ? "Submitting..." : "Send Reset Link" }}</span>
                  </v-btn>
                </div>
              </v-card>
            </div>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      email: '',
      isLoading: false,

      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+\..+/.test(v) || 'Email must be valid',
      ]
    };
  },
  computed: {
    emailValid() {
      return this.email && /.+@.+\..+/.test(this.email)
    }
  },
  mounted() {
    document.title = "PettyCash Savings | Forgotten Password";
    this.$store.commit('setCloseURL', "/");
  },
  methods: {
    async requestPasswordReset() {
      this.isLoading = true; 

      try {
        const response = await axios.post('/api/v1/home/reset/', {
          email: this.email
        });

        this.$store.commit('setSnackBarMessage', response.data.message || 'Password reset instructions have been sent to your email');
        this.$store.commit('setSnackBarColor', "teal darken-4");
        this.$store.commit('activateSnackBar', true);
        
        // Clear email field after successful submission
        this.email = '';
        
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response) {
          switch (error.response.status) {
            case 404:
              errorMessage = 'No account found with this email address';
              break;
            case 400:
              errorMessage = error.response.data.error || 'Invalid request';
              break;
          }
        }
        this.$store.commit('setSnackBarMessage', errorMessage);
        this.$store.commit('setSnackBarColor', "red darken-4");
        this.$store.commit('activateSnackBar', true);
      } finally {
        this.isLoading = false; 
      }
    }
  },
};
</script>

<style scoped>
.white-bg {
  background-color: rgb(255, 255, 255) !important;
}
</style>